import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';

export const recurringJournalApi = {
  getList: (params?: unknown) =>
    apiClient.get<ApiResponse<PagedResult<unknown>>>('/recurring-journals', { params }),
  getById: (id: string) =>
    apiClient.get<ApiResponse<unknown>>(`/recurring-journals/${id}`),
  create: (data: unknown) =>
    apiClient.post<ApiResponse<unknown>>('/recurring-journals', data),
  update: (id: string, data: unknown) =>
    apiClient.put<ApiResponse<unknown>>(`/recurring-journals/${id}`, data),
  remove: (id: string) =>
    apiClient.delete<ApiResponse<void>>(`/recurring-journals/${id}`),
  execute: (id: string) =>
    apiClient.post<ApiResponse<unknown>>(`/recurring-journals/${id}/execute`),
  /** The state to move TO. The endpoint defaults to activate, so omitting it can never deactivate. */
  setActive: (id: string, activate: boolean) =>
    apiClient.post<ApiResponse<void>>(`/recurring-journals/${id}/toggle-status`, null, { params: { activate } }),
};
